import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {ActionRow, ActionRowButton, Icon, SectionHeading} from "peggirkit";
import {ArrowDownTrayIcon} from "@heroicons/react/24/outline";
import {DayReport} from "@/data/entities/dayReport";
import {SetStateFn} from "@/utils/SetStateUtils";
import DayReportTable from "@widgets/reports/dayReport/summary/DayReportTable";

type Props = {
    dayReport: DayReport,
    setShowExportModal: SetStateFn<boolean>,
};

/**
 * One row with exactly the contents of the CSV export.
 */
const DayReportSummary = ({dayReport, setShowExportModal}: Props) => {
    const intl = useIntl();
    const headerActions = (
        <ActionRow>
            <ActionRowButton
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => setShowExportModal(true),
                    },
                }}
                showInRowBreakpoint="alwaysInMore"
                iconBefore={<Icon icon={ArrowDownTrayIcon}/>}
                color={"secondary"}
                variant={"solid"}
            >
                <FormattedMessage id={"dayReport.exportCsv"}/>
            </ActionRowButton>
        </ActionRow>
    );

    return (
        <div className={"mt-6 md:mt-12 pb-12 flex flex-col gap-4"}>
            <SectionHeading
                title={<FormattedMessage id={"dayReport.summary"}/>}
                description={intl.formatMessage({id: "dayReport.summary.description"})}
                actions={{
                    actionRow: headerActions,
                    horizontal: false,
                }}
                breakpoints={{
                    md: {
                        actions: {
                            actionRow: headerActions,
                            horizontal: true,
                        },
                    },
                }}
            />

            <DayReportTable dayReport={dayReport}/>
        </div>
    );
};

export default DayReportSummary;